// extracted by mini-css-extract-plugin
module.exports = {"modalMap":"src-components-hotel-MapModal-styles__modalMap","modalBody":"src-components-hotel-MapModal-styles__modalBody","mapBody":"src-components-hotel-MapModal-styles__mapBody"};